import { MapPin } from "@phosphor-icons/react";
import { CONTACT } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const AREAS = ["Chicago", "Evanston", "Oak Park", "Cicero", "Skokie", "Berwyn", "Elmwood Park", "Norridge", "Lincolnwood", "Forest Park"];

export const ServiceArea = () => (
  <section data-testid="service-area" className="relative border-t border-white/10 py-24 md:py-32">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-6 md:px-12 lg:grid-cols-[1fr_1.2fr] lg:items-center">
      <Reveal>
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-brand-cyan" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">Service Area</span>
        </div>
        <h2 className="font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
          Chicago and the surrounding {CONTACT.radius.replace("~", "")}.
        </h2>
        <p className="mt-6 max-w-lg font-body text-base leading-relaxed text-slatex-300">
          We serve Chicago and nearby suburbs within an approximate 20-mile radius. For commercial projects, our service area is flexible depending on scope.
        </p>
        <div className="mt-8 flex flex-wrap gap-2">
          {AREAS.map((a) => (
            <span key={a} className="flex items-center gap-1.5 border border-white/12 bg-panel px-3 py-1.5 font-mono text-[11px] uppercase tracking-wide text-slatex-300">
              <MapPin size={11} weight="fill" className="text-brand-cyan" /> {a}
            </span>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="relative aspect-square w-full overflow-hidden border border-white/10 bg-panel">
          <div className="blueprint-grid absolute inset-0 opacity-60" />
          {/* concentric radius rings */}
          <div className="absolute inset-0 flex items-center justify-center">
            {[0.35, 0.6, 0.85].map((s, i) => (
              <div key={s} className="absolute rounded-full border border-brand-cyan/25" style={{ width: `${s * 100}%`, height: `${s * 100}%` }}>
                {i === 2 && <span className="absolute -top-3 left-1/2 -translate-x-1/2 font-mono text-[9px] uppercase tracking-widest text-brand-cyan/70 bg-ink px-1">20 mi</span>}
              </div>
            ))}
            <div className="pulse-ring absolute h-16 w-16 rounded-full border border-brand-cyan/40" />
            <div className="relative z-10 flex flex-col items-center">
              <MapPin size={28} weight="fill" className="text-brand-cyan cyan-glow" />
              <span className="mt-2 font-mono text-[10px] uppercase tracking-widest text-white">Chicago, IL</span>
            </div>
          </div>
          {/* crosshair lines */}
          <div className="absolute left-1/2 top-0 h-full w-px bg-brand-cyan/15" />
          <div className="absolute left-0 top-1/2 h-px w-full bg-brand-cyan/15" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default ServiceArea;
